/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import Select, { Props } from 'react-select';
import { Controller } from 'react-hook-form';
import _ from 'lodash';
import { PaginationType } from '../../../../hooks/useFetch';
import { buildSelectStyles, selectComponentOverrides } from '../../../ui/select-styles';

interface SelectInputFormProps extends Props {
  name: string | undefined | any;
  label: string | undefined;
  options: any;
  pagination?: PaginationType;
  getOptions?: (props: any) => void;
  isRequired?: boolean;
  control: any;
  errors: any;
}

export const SelectInputForm = ({
  name,
  label,
  options,
  pagination,
  getOptions,
  isRequired,
  control,
  errors,
  ...rest
}: SelectInputFormProps) => {
  // const [formattedOptions, setFormattedOptions] = useState<any>([]);
  const [filter, setFilter] = useState({
    page: 1,
    per_page: 30,
    search: '',
  });
  const pageRef = useRef(1);

  const searchItem = (inputValue) => {
    setFilter((oldState) => ({
      ...oldState,
      page: 1,
      search: inputValue,
    }));
  };

  const onMenuScrollToBottom = () => {
    const nextPage = pageRef.current + 1;
    if (pagination?.has_next) {
      setFilter((oldState) => ({
        ...oldState,
        page: nextPage,
      }));

      pageRef.current = nextPage;
    }
  };

  const onMenuScrollToTop = () => {
    if (pagination?.has_prev) {
      let prevPage = pageRef.current - 1;
      prevPage = prevPage > 0 ? prevPage : 1;
      setFilter((oldState) => ({
        ...oldState,
        page: prevPage,
      }));

      pageRef.current = prevPage;
    }
  };

  useEffect(() => {
    if (getOptions) getOptions(filter);
  }, [filter]);

  return (
    <FormControl isRequired={isRequired} isInvalid={!!_.get(errors, name)}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange, onBlur, ref } }) => {
          const handleChange = (newValue) => {
            if (rest?.isMulti) {
              onChange(newValue || []);
            } else {
              onChange(newValue);
            }
          };

          const controlledValue = rest?.isMulti ? value || [] : value || null;

          return (
            <Select
              options={options}
              ref={ref}
              value={controlledValue}
              onChange={handleChange}
              isClearable
              isSearchable
              onInputChange={getOptions ? searchItem : () => {}}
              onBlur={onBlur}
              noOptionsMessage={() => 'Nenhum resultado encontrado'}
              loadingMessage={() => 'Carregando...'}
              onMenuClose={() => {
                pageRef.current = 1;
              }}
              onMenuScrollToBottom={getOptions ? onMenuScrollToBottom : () => {}}
              onMenuScrollToTop={getOptions ? onMenuScrollToTop : () => {}}
              styles={buildSelectStyles({ hasError: !!_.get(errors, name) })}
              components={selectComponentOverrides}
              inputId={name}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              {...rest}
            />
          );
        }}
      />
      {_.get(errors, name) && <FormErrorMessage>{_.get(errors, name)?.message}</FormErrorMessage>}
    </FormControl>
  );
};
